import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './status-open.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function StatusOpen(props: IconProps) {
  return <Icon tw="stroke-current" className={props.className} />;
}
